export const activities = {
  food: [
    'healthy',
    'soup',
    'vegetables',
    'meat',
    'fish',
    'no meal',
    'bread',
    'breakfast',
    'lunch',
    'pizza',
    'sweets',
    'dinner',
    'fruits',
    'chocolate',
  ],
  drink: [
    'water',
    'tea',
    'alcohol',
    'milk',
    'coffee',
    'espresso',
    'juice',
    'pop',
  ],
  leisure: [
    'cafe',
    'casino',
    'concert',
    'makeup',
    'cinema',
    'hairdresser',
    'museum',
    'surfing',
    'relax',
    'watch tv',
    'travel',
    'walking',
    'peeling apples',
  ],
  hobbies: [
    'cars',
    'billiards',
    'bowling',
    'dancing',
    'cooking',
    'music',
    'fishing',
    'gardening',
    'camping',
    'gaming',
    'sewing',
    'reading',
    'writing',
    'meditation',
    'art',
    'computer',
  ],
  health: [
    'smokefree',
    'dentist',
    'headache',
    'medication',
    'smoke',
    'pain',
    'on period',
    'sick',
    'doctor',
  ],
  social: [
    'argue',
    'cuddle',
    'family',
    'love',
    'friends',
    'meetup',
    'discussion',
    'help',
    'party',
    'date',
    'chat',
    'phone call',
    'sex',
    'pray',
    'talk',
  ],
  work: [
    'college',
    'household',
    'learning',
    'school',
    'university',
    'commute',
    'working',
    'meeting',
    'sick leave',
  ],
  occasions: [
    'wedding',
    'birthday',
    'graduation',
    'breakup',
    'funeral',
    'anniversary',
  ],
  sports: [
    'diving',
    'football',
    'cycling',
    'climbing',
    'boxing',
    'basketball',
    'cricket',
    'tennis',
    'gym',
    'baseball',
    'running',
    'soccer',
    'riding',
    'hiking',
    'swimming',
    'yoga',
  ],
};

export const categories = [
  ['food', 'drink', 'leisure', 'hobbies'],
  ['health', 'social', 'work', 'occasions'],
  ['sports'],
];
